import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgbAlertModule,
  NgbAccordionModule,
  NgbModalModule,
  NgbNavModule,
  NgbToastModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";

import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { ScrollspyDirective } from "./scrollspy.directive";
import { ProgressComponent } from "./loading/progress-bar/progress.component";
import { SpinnerComponent } from "./loading/spinner/spinner.component";
import { AlertsComponent } from "./alerts/alerts.component";
import { ToastsContainer } from "./toasts/toasts-container.component";
import { CreateDateRangeValidatorDirective } from "./custom-validators/create-date-range-validator.directive";
import { TranslateModule } from "@ngx-translate/core";
import { FilterCountPipe } from "./pipes/filter-count.pipe";
import { PermissionDirective } from "./custom-directive/permission.directive";
import { CloseSelectsOnScrollDirective } from "./custom-directive/close-selects-on-scroll.directive";
import { DateDigitsMaskModule } from "./custom-directive/date-digits-mask.module";
import { ToastsHeaderBEContainer } from "./toasts/toasts-header-be-container.component";
import { LockedComponent } from "./locked/locked.component";
import { CalendarEventComponent } from "./modals/calendar-event/calendar-event.component";
import { ProposalComponent } from "./modals/proposal/proposal.component";
import { VisitFormComponent } from "./modals/visit-form/visit-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlatpickrModule } from "angularx-flatpickr";
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import { english } from "flatpickr/dist/l10n/default";
import { NgSelectModule } from "@ng-select/ng-select";
import { MediationContractComponent } from "./modals/mediation-contract/mediation-contract.component";
import { MediationContractLegacyComponent } from "./modals/mediation-contract-legacy/mediation-contract-legacy.component";
import { ProspectingFormComponent } from "./modals/prospecting-form/prospecting-form.component";
import { NgxMaskModule } from "ngx-mask";
import { ProposalTemplateComponent } from "./modals/proposal/template/proposal-template/proposal-template.component";
import { ProposalViewComponent } from "./components/proposal-view/proposal-view.component";
import { VisitFormTemplateComponent } from "./modals/visit-form/template/visit-form-template/visit-form-template.component";
export function flatpickrFactory(lang: any) {
  switch (lang) {
    case "pt":
      flatpickr.localize(Portuguese);
      break;
    default:
      flatpickr.localize(english);
      break;
  }
  return flatpickr;
}
import { FormatNumberPipe } from "./pipes/format-number.pipe";
import { ContactOverviewComponent } from "./components/contact-overview/contact-overview.component";
import { ContactOverviewActivityComponent } from "./components/contact-overview/contact-overview-activity.component";
import { ContactOverviewPropertyCardComponent } from "./components/contact-overview/contact-overview-property-card.component";
import { SimplebarAngularModule } from "simplebar-angular";
import { SaleFormComponent } from "./modals/sale-form/sale-form.component";
import { ShowcaseSheetComponent } from './components/showcase-sheet/showcase-sheet.component';
import { SimulatorsModalComponent } from "./modals/simulators/simulators-modal.component";
import { SendToPromoterModalComponent } from "./modals/send-to-promoter/send-to-promoter-modal.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { IconPickerComponent } from "./components/icon-picker/icon-picker.component";

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    ProgressComponent,
    SpinnerComponent,
    AlertsComponent,
    ToastsContainer,
    CreateDateRangeValidatorDirective,
    FilterCountPipe,
    PermissionDirective,
    CloseSelectsOnScrollDirective,
    ToastsHeaderBEContainer,
    LockedComponent,
    FormatNumberPipe,
    ContactOverviewComponent,
    ContactOverviewActivityComponent,
    ContactOverviewPropertyCardComponent,
    CalendarEventComponent,
    ProposalComponent,
    VisitFormComponent,
    MediationContractComponent,
    MediationContractLegacyComponent,
    ProspectingFormComponent,
    ProposalTemplateComponent,
    ProposalViewComponent,
    VisitFormTemplateComponent,
    SaleFormComponent,
    ShowcaseSheetComponent,
    SimulatorsModalComponent,
    SendToPromoterModalComponent,
    IconPickerComponent,
  ],
  imports: [
    CommonModule,
    NgbAlertModule,
    NgbAccordionModule,
    NgbToastModule,
    TranslateModule,
    SimplebarAngularModule,
    NgbModalModule,
    FormsModule,
    ReactiveFormsModule,
    FlatpickrModule,
    NgSelectModule,
    NgbTooltipModule,
    NgbNavModule,
    NgxMaskModule.forRoot(),
    DragDropModule,
    DateDigitsMaskModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    DateDigitsMaskModule,
    ProgressComponent,
    SpinnerComponent,
    AlertsComponent,
    FilterCountPipe,
    PermissionDirective,
    CloseSelectsOnScrollDirective,
    ToastsContainer,
    ToastsHeaderBEContainer,
    LockedComponent,
    FormatNumberPipe,
    ContactOverviewComponent,
    CalendarEventComponent,
    ProposalComponent,
    VisitFormComponent,
    SaleFormComponent,
    ProposalViewComponent,
    MediationContractComponent,
    MediationContractLegacyComponent,
    ShowcaseSheetComponent,
    SimulatorsModalComponent,
    SendToPromoterModalComponent,
    IconPickerComponent,
  ],
})
export class SharedModule {}
